<template>
  <div class="photo-wall">
    <el-form ref="form" :model="form" label-width="80px" label-position="left">
      <el-form-item :label="$t('microSite.common.form.title')">
        <el-input v-model="form.title" :placeholder="$t('microSite.common.form.titlePlaceholder')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.common.form.subtitle')">
        <el-input v-model="form.subTitle" :placeholder="$t('microSite.common.form.subtitlePlaceholder')"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import editorTemplate from '../../editorTemplate'

export default {
  mixins: [editorTemplate],
  data () {
    return {
      form: {
        title: null,
        subTitle: null
      }
    }
  },
  computed: {

  },
  created () {
    const props = this.renderData.data.props
    this.form.title = props.title
    this.form.subTitle = props.subTitle
  },
  methods: {
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.title = this.form.title
      props.subTitle = this.form.subTitle
      this.updateConfigInRoot()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
